const configuredSiteUrl = process.env.REACT_APP_SITE_URL?.trim();
const normalizedConfiguredUrl = configuredSiteUrl
  ? configuredSiteUrl.replace(/\/+$/, "")
  : "";

export const SITE_URL = normalizedConfiguredUrl || "https://vessella.com";
export const ORGANIZATION_NAME = "Vessella Group";
export const DEFAULT_OG_IMAGE = "/vessella-logo.png";
export const DEFAULT_ROBOTS =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

export const SOCIAL_PROFILE_URLS = [
  "https://www.facebook.com/vessellagroup/",
  "https://www.instagram.com/vessellagroup/",
  "https://in.linkedin.com/company/vessella-group",
  "https://www.youtube.com/@vessellagrouphyd",
];

export const ORGANIZATION_CONTACT = {
  email: "info@vessella.in",
  telephone: "+91-91212-44421",
};

export const ORGANIZATION_ADDRESS = {
  streetAddress: "1st Floor, East Block, Cyber Meadows, Kondapur",
  addressLocality: "Hyderabad",
  postalCode: "500084",
  addressRegion: "Telangana",
  addressCountry: "IN",
};

const COMMON_KEYWORDS = [
  "Vessella Group",
  "villas in Hyderabad",
  "luxury villas Hyderabad",
  "gated community villas",
  "premium villas",
  "real estate Hyderabad",
];

const PAGE_SEO = {
  "/": {
    title: "Luxury Villas in Hyderabad | Vessella Group",
    description:
      "Explore luxury villas, premium gated communities, and upcoming residential projects by Vessella Group in Hyderabad.",
    keywords: [
      ...COMMON_KEYWORDS,
      "Vessella projects",
      "new villas Hyderabad",
      "HMDA approved villas",
    ],
  },
  "/about-us": {
    title: "About Vessella Group | Legacy of Premium Villa Communities",
    description:
      "Learn about Vessella Group, our vision, mission, and commitment to designing premium villa communities with quality and transparency.",
    keywords: [...COMMON_KEYWORDS, "about Vessella", "Vessella builders Hyderabad"],
  },
  "/projects": {
    title: "Vessella Projects | Ongoing, Completed and Upcoming Villas",
    description:
      "Browse ongoing, completed, and upcoming Vessella projects including luxury villas and premium residential communities in Hyderabad.",
    keywords: [...COMMON_KEYWORDS, "ongoing projects", "upcoming villas"],
  },
  "/contact": {
    title: "Contact Vessella Group | Enquire About Villas in Hyderabad",
    description:
      "Connect with Vessella Group for villa enquiries, site visits, project details, and pricing information in Hyderabad.",
    keywords: [...COMMON_KEYWORDS, "contact Vessella", "villa enquiry Hyderabad"],
  },
  "/privacy-policy": {
    title: "Privacy Policy | Vessella Group",
    description:
      "Read the privacy policy for Vessella Group and understand how website visit data and personal information are handled.",
    keywords: ["Vessella privacy policy", "privacy policy"],
    robots: "noindex, follow",
  },
  "/serene": {
    title: "Vessella Serene | Luxury Villas in Narsingi, Hyderabad",
    description:
      "Discover Vessella Serene, a premium villa community with modern amenities, elegant master planning, and serene living in Hyderabad.",
    keywords: [...COMMON_KEYWORDS, "Vessella Serene", "luxury villas Narsingi"],
  },
  "/palms": {
    title: "Vessella Palms | Premium Villas and Clubhouse in Hyderabad",
    description:
      "Explore Vessella Palms, featuring premium villas, thoughtfully designed amenities, and a refined gated community lifestyle.",
    keywords: [...COMMON_KEYWORDS, "Vessella Palms", "premium villas Hyderabad"],
  },
  "/meadows": {
    title: "Vessella Meadows | Gated Community Villas in Hyderabad",
    description:
      "Visit Vessella Meadows to explore completed premium villas, master plan details, location benefits, and community amenities.",
    keywords: [...COMMON_KEYWORDS, "Vessella Meadows", "gated community Hyderabad"],
  },
  "/woods": {
    title: "Vessella Woods | Premium Residential Villas in Hyderabad",
    description:
      "Explore Vessella Woods for thoughtfully crafted villas, spacious living, and lifestyle amenities in a premium neighborhood.",
    keywords: [...COMMON_KEYWORDS, "Vessella Woods", "residential villas Hyderabad"],
  },
  "/villas": {
    title: "Vessella Villas | Luxury Villas in Hyderabad",
    description:
      "Discover Vessella Villas with premium layouts, elegant amenities, and timeless architecture for modern family living in Hyderabad.",
    keywords: [...COMMON_KEYWORDS, "Vessella Villas", "luxury gated villas Hyderabad"],
  },
  "/cyber-meadows": {
    title: "Cyber Meadows | Vessella Premium Residential Community",
    description:
      "Explore Cyber Meadows by Vessella for premium residential living, curated amenities, and excellent location connectivity.",
    keywords: [...COMMON_KEYWORDS, "Cyber Meadows", "premium community Hyderabad"],
  },
  "/mokhila": {
    title: "Mokhila | Upcoming Vessella Project in Hyderabad",
    description:
      "Get updates on the upcoming Vessella Mokhila project and stay informed about launch details, location, and availability.",
    keywords: [...COMMON_KEYWORDS, "Mokhila project", "upcoming villas Hyderabad"],
  },
  "/karimnagar": {
    title: "Karimnagar | Upcoming Vessella Project",
    description:
      "Track updates for Vessella's upcoming Karimnagar project, including launch announcements and project details.",
    keywords: ["Vessella Karimnagar", "upcoming real estate project"],
  },
  "/tspa": {
    title: "TSPA | Upcoming Vessella Project in Hyderabad",
    description:
      "Stay updated on the upcoming Vessella TSPA project with information on launch timelines and development progress.",
    keywords: [...COMMON_KEYWORDS, "TSPA project", "upcoming gated community"],
  },
  "/kismathpur": {
    title: "TSPA | Upcoming Vessella Project in Hyderabad",
    description:
      "Stay updated on the upcoming Vessella TSPA project with information on launch timelines and development progress.",
    keywords: [...COMMON_KEYWORDS, "TSPA project", "upcoming gated community"],
    canonicalPath: "/tspa",
    robots: "noindex, follow",
  },
  "/narsingi": {
    title: "Narsingi | Upcoming Vessella Project",
    description:
      "Find the latest updates on Vessella's upcoming Narsingi project and upcoming launch information.",
    keywords: [...COMMON_KEYWORDS, "Narsingi project", "upcoming villas Narsingi"],
  },
  "/tukkaguda": {
    title: "Tukkaguda | Upcoming Vessella Project in Hyderabad",
    description:
      "Get updates on the upcoming Vessella Tukkaguda residential project with launch dates and project availability details.",
    keywords: [...COMMON_KEYWORDS, "Tukkaguda project", "upcoming villas Tukkaguda"],
  },
  "/mokilla": {
    title: "Mokhila | Upcoming Vessella Project in Hyderabad",
    description:
      "Get updates on the upcoming Vessella Mokhila project and stay informed about launch details, location, and availability.",
    keywords: [...COMMON_KEYWORDS, "Mokhila project", "upcoming villas Hyderabad"],
    canonicalPath: "/mokhila",
    robots: "noindex, follow",
  },
  "/kishmathpur": {
    title: "TSPA | Upcoming Vessella Project in Hyderabad",
    description:
      "Stay updated on the upcoming Vessella TSPA project with information on launch timelines and development progress.",
    keywords: [...COMMON_KEYWORDS, "TSPA project", "upcoming gated community"],
    canonicalPath: "/tspa",
    robots: "noindex, follow",
  },
};

const FALLBACK_PAGE_SEO = {
  title: "Vessella Group | Luxury Villas and Premium Projects",
  description:
    "Vessella Group develops premium villa communities and luxury residential projects in Hyderabad.",
  keywords: COMMON_KEYWORDS,
  robots: "noindex, follow",
};

export const normalizePath = (path = "/") => {
  const withoutHash = path.split("#")[0];
  const withoutQuery = withoutHash.split("?")[0];

  if (!withoutQuery || withoutQuery === "/") {
    return "/";
  }

  return withoutQuery.replace(/\/+$/, "") || "/";
};

export const toAbsoluteUrl = (path = "/") => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
};

export const getPageSeo = (pathname) => {
  const normalizedPath = normalizePath(pathname);
  const pageSeo = PAGE_SEO[normalizedPath] || FALLBACK_PAGE_SEO;
  const canonicalPath = normalizePath(pageSeo.canonicalPath || normalizedPath);
  const imagePath = pageSeo.imagePath || DEFAULT_OG_IMAGE;

  return {
    ...pageSeo,
    canonicalPath,
    imagePath,
    url: toAbsoluteUrl(canonicalPath),
    imageUrl: toAbsoluteUrl(imagePath),
    robots: pageSeo.robots || DEFAULT_ROBOTS,
    keywords: pageSeo.keywords || COMMON_KEYWORDS,
  };
};
